var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLegend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8533 49.3087L39.8168 25.1481C40.2753 24.5441 39.8168 23.7387 39.0666 23.6984H31.0643C30.4808 23.6984 30.0223 23.2555 30.0223 22.6918V1.99419C30.0223 1.02776 28.7302 0.625086 28.1467 1.43044L10.1832 25.591C9.72474 26.1548 10.1832 27.0004 10.9334 27.0004H18.8941C19.4776 27.0004 19.9777 27.4433 19.9777 28.0474V48.7047C19.9777 49.7114 21.2698 50.114 21.8533 49.3087ZM26.4342 11.6963C26.7371 11.2768 26.6425 10.6911 26.223 10.3882C25.8034 10.0853 25.2177 10.1798 24.9148 10.5994L16.7526 21.9051C16.4497 22.3247 16.5443 22.9104 16.9639 23.2133C17.3834 23.5162 17.9691 23.4216 18.272 23.002L26.4342 11.6963Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegend);
export default __webpack_public_path__ + "static/media/legend.35af2eac.svg";
export { ForwardRef as ReactComponent };